import React from 'react';

export enum BUTTON_VER {
  primary = 'primary',
  secondary = 'secondary',
}

export enum BUTTON_TYPE {
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset',
}

export interface ButtonInterface {
  type: BUTTON_TYPE;
  ver: BUTTON_VER;
  text: string;
  extraClass?: string;
  onClick?: (() => void) | ((e: React.MouseEvent<HTMLButtonElement>) => void);
  // | ((n: number) => void);
  disabled?: boolean;
  customWidth?: number;
}
